export default "__VITE_ASSET__DzVGNczt__"